import 'globals';

// Die Klasse Columns bekommt durch das BasePackage einen Z-index zugeteilt.
// Dadurch ist es nicht möglich, ein Dropdown zu erstellen, der zwischen
// zwei Columns auftritt, da Z-index der Hirachie Ordnung folgt.
// Hier wird nach den Karriere-Teasern gesucht und dann wird an das
// Columns Div eine zusätzliche klasse vergeben, die den Z-index Wert ändert.

$(document).ready(function() {
    $('.career-offer-teaser').each(function() {
        $(this).parents('.columns').addClass('career-offer-teaser-box');
    });
});
